import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';

const BaseTool = cornerstoneTools.importInternal('base/BaseTool');
const cursors = cornerstoneTools.import('tools/cursors');
const panCursor = cursors.panCursor;

export default class PanToolBroadcast extends BaseTool {
	constructor(props = {}) {
		const defaultProps = {
			name: 'PanBroadcast',
			supportedInteractionTypes: ['Mouse', 'Touch'],
			svgCursor: panCursor,
            configuration: {
                magnifySize: 1,
                magnificationLevel: 1,
              }, 
		};

		super(props, defaultProps);

		// Touch
		this.touchDragCallback = this._dragCallback.bind(this);
		// Mouse
		this.mouseDragCallback = this._dragCallback.bind(this);

        // const isViewLocked = index => {
        //     if (index < window.__lockedDocuments.length) {
        //         return window.__lockedDocuments[index];
        //     }
        //     return false;
        // };
	}

	_dragCallback(evt) {
		const eventData = evt.detail;
		const { element, viewport } = eventData;

		const translation = this._getTranslation(eventData);

		this._applyTranslation(viewport, translation);

        window.dispatchEvent(new CustomEvent('panChange', {
            detail: {
                viewIndex: this.options.viewIndex,
                translation: translation,
                eventData: eventData
            }
        }));

		cornerstone.setViewport(element, viewport);
	}

	_getTranslation(eventData) {
		const { viewport, image, deltaPoints } = eventData;

		let widthScale = viewport.scale;
		let heightScale = viewport.scale;

		if (image.rowPixelSpacing < image.columnPixelSpacing) {
			widthScale *= image.columnPixelSpacing / image.rowPixelSpacing;
		} else if (image.columnPixelSpacing < image.rowPixelSpacing) {
			heightScale *= image.rowPixelSpacing / image.columnPixelSpacing;
		}

		return {
			x: deltaPoints.page.x / widthScale,
			y: deltaPoints.page.y / heightScale,
		};
	}

	_applyTranslation(viewport, translation) {
		viewport.translation.x += translation.x;
		viewport.translation.y += translation.y;
	}
}
